import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import b from 'b_';
import SnackStore from '../../stores/SnackStore';
import Table from '../Fuse/Table';
import { Card } from '../Fuse';
import RoleAccessModal from './RoleAccessModal';
import Administrators from '../Administrators/Administrators';
import { fetchDisplayRoleName } from '../../stores/Administrators/AdministratorModalStore';
import RoleAccessStore from '../../stores/RoleAccess/RoleAccessStore';
import AdministratorsStore from '../../stores/Administrators/AdministratorsStore';
import './SAMLAccess.css';

const block = b.lock('SAMLAccess');

class SAMLAccess extends Component {
    static propTypes = {
        roleAccess: RoleAccessStore.PropType.isRequired,
        userAccess: AdministratorsStore.PropType.isRequired,
        currentUserId: PropTypes.number.isRequired,
        snack: SnackStore.PropType.isRequired,
        midComponentHook: PropTypes.node,
        readOnly: PropTypes.bool,
    };

    roleAccessColumns = [
        {
            name: 'role',
            title: 'Role',
            render: (item) => fetchDisplayRoleName(item.value),
        },
        {
            name: 'groups',
            title: 'User Groups',
            render: (item) => {
                if (item.groups.length === 0 && !this.props.readOnly) {
                    return <div className={block('EmptyGroups')}>
                        Add Full Access administrators by&nbsp;
                        <a
                            className={block('AddFirstItemLink')}
                            onClick={() => this.props.roleAccess.openModal()}
                        >
                            selecting User Groups
                        </a>
                    </div>;
                }
                return <div className={block('GroupNames')}>
                    {item.groups.map((group, index) =>
                        <span key={index} className={block('GroupPill', { unsync: group.unsync })}>
                            {!group.unsync ? group.name : <Fragment>
                                <span className={block('UnsyncGroupName')}>{group.name}</span>
                                {' (group not synchronized)'}
                            </Fragment>}
                        </span>)}
                </div>;
            },
        },
    ];

    roleAccessActions = [
        {
            label: 'Edit',
            icon: 'edit',
            onPress: () => this.props.roleAccess.openModal(),
        },
    ];

    componentWillMount() {
        this.loadData(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.roleAccess !== this.props.roleAccess) {
            this.loadData(nextProps);
        }
    }

    loadData = (props) => {
        props.roleAccess.load()
            .catch((error) => this.props.snack.showError(`Failed to load roles' groups ${error.message}`));
    };

    render() {
        const { roleAccess, userAccess, currentUserId, readOnly } = this.props;

        return <Fragment>
            <Card className={block('TableCardContainer')}>
                <Table
                    header="Role Access"
                    cellClassName={block('RolesCell')}
                    items={roleAccess.roles}
                    loading={roleAccess.listStatus.isLoading}
                    columns={this.roleAccessColumns}
                    actions={readOnly ? null : this.roleAccessActions}
                />
            </Card>
            {this.props.midComponentHook ? this.props.midComponentHook : null}
            <Administrators
                header="User Access"
                addFirstAdminLink="adding a User Access administrator"
                modalSubtitle="User Access"
                currentUserId={currentUserId}
                readOnly={readOnly}
                store={userAccess}
            />

            <RoleAccessModal store={roleAccess} />
        </Fragment>;
    }
}

export default inject('snack')(observer(SAMLAccess));
